import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SellerRegistrationRequestList from './SellerRegistrationRequestList';

export default {
  list: SellerRegistrationRequestList,
  icon: PersonAddIcon,
};
